(() => {
  window.addEventListener("load", () => {
    const chosenWrapper = document.querySelector(".chosen-wrapper");
    if (chosenWrapper) {
      new Filter(chosenWrapper);
    }
  });

  function handleize(str) {
      return str
      .toLowerCase()
      .trim()
      .normalize("NFD")                     // Remove accents
      .replace(/[\u0300-\u036f]/g, "")      // Remove diacritics
      .replace(/[^a-z0-9]+/g, "-")          // Replace non-alphanumeric with hyphens
      .replace(/^-+|-+$/g, "");             // Trim leading/trailing hyphens
  }

  class Filter {
    constructor(container) {
      const dataUrls = container.dataset.urls;
      this.collectionPosition = Number(container.dataset.collectionPosition);

      this.elms = {
        container,
        field1: container.querySelector(".chosen-container[data-field-index='1']"),
        field2: container.querySelector(".chosen-container[data-field-index='2']"),
        field3: container.querySelector(".chosen-container[data-field-index='3']"),
        buttonSubmit: container.querySelector(".js-btn-submit"),
        buttonReset: container.querySelector(".js-btn-reset")
      };

      this.getData(dataUrls).then(data => {
        data = data.flat(2);
        this.initField(this.elms.field1, data);
        this.initEventFieldTitle();
        this.initEventButtonReset();
        this.initEventButtonSubmit();
      });
    }

    initField(element, data, lastField = false) {
      const values = lastField ? data : data.map(item => item.name);
      const index = element.dataset.fieldIndex;
      const titleElement = element.querySelector(".js-title");
      const results = element.querySelector(".chosen-results");
      const drop = element.querySelector(".chosen-drop");

      results.innerHTML = "";

      values.forEach(value => {
        const li = document.createElement("li");
        li.classList.add("active-result");
        li.textContent = String(value).toUpperCase();
        li.dataset.value = value;
        results.appendChild(li);
      });

      Array.from(results.children).forEach(li => {
        li.addEventListener("click", e => {
          e.stopPropagation();
          const value = e.currentTarget.dataset.value;
          titleElement.textContent = value;
          element.dataset.value = value;
          drop.classList.remove("active");
          this.change(index, data, value);
        });
      });
    }

    setField(element, value, data, lastField = false) {
      this.initField(element, data, lastField);
      element.dataset.value = value;
      element.querySelector(".js-title").textContent = value.toUpperCase();
      element.classList.add("active");
    }

    change(index, data, value) {
      const { field2, field3 } = this.elms;
      const selected = String(value ?? "").toLowerCase();

      if (index === "1") {
        const item = data.find(i =>
          String(i?.name ?? "").toLowerCase() === selected
        );
        if (!item || !item.field_2) return;

        this.resetField(field2);
        this.resetField(field3);
        this.initField(field2, item.field_2);
        field2.classList.add("active");
        field2.querySelector(".chosen-drop").classList.add("active");
      }

      if (index === "2") {
        const item = data.find(i =>
          String(i?.name ?? "").toLowerCase() === selected
        );
        if (!item || !item.field_3) return;

        this.resetField(field3);
        this.initField(field3, item.field_3, true);
        field3.classList.add("active");
        field3.querySelector(".chosen-single").click();
      }
    }


    resetField(element) {
      const title = element.querySelector(".js-title");
      element.classList.remove("active");
      title.textContent = title.dataset.placeholder || "";
      element.dataset.value = "";
      element.querySelector(".chosen-results").innerHTML = "";
    }

    initEventFieldTitle() {
      this.elms.container.querySelectorAll(".chosen-container").forEach(container => {
        const trigger = container.querySelector(".chosen-single");
        const drop = trigger.nextElementSibling;
        const search = container.querySelector("input[name='search']");
        const results = container.querySelector(".chosen-results");

        trigger.addEventListener("click", e => {
          e.stopPropagation();
          drop.classList.toggle("active");
        });

        document.addEventListener("click", e => {
          if (!container.contains(e.target)) {
            drop.classList.remove("active");
          }
        });

        if (search) {
          search.addEventListener("input", () => {
            const val = search.value.toLowerCase();
            Array.from(results.children).forEach(li => {
              li.style.display = li.textContent.toLowerCase().includes(val)
                ? "block"
                : "none";
            });
          });
        }
      });
    }

    getData(urls) {
      return Promise.all(
        urls.split(",").map(url =>
          fetch(url).then(res => res.json())
        )
      );
    }

    initEventButtonReset() {
      const { field1, field2, field3, buttonReset } = this.elms;
      if (!buttonReset) return;

      buttonReset.addEventListener("click", () => {
        this.resetField(field1);
        field1.classList.add("active");
        this.resetField(field2);
        this.resetField(field3);
      });
    }
    initEventButtonSubmit() {
      const { buttonSubmit, field1, field2, field3 } = this.elms;
      if (!buttonSubmit) return;

      buttonSubmit.addEventListener("click", () => {
        const values = [
          field1.dataset.value,
          field2.dataset.value,
          field3.dataset.value
        ];

        const slug = s =>
          s.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-");

        const base = values[this.collectionPosition];
        const rest = values
          .filter((_, i) => i !== this.collectionPosition)
          .map(slug)
          .join("+");

        /*window.location.href =
          `${Theme.routes.collectionsUrl}/${slug(base)}/`;*/

        const r = handleize(values[this.collectionPosition]);
        window.location.href =
          `${Theme.routes.collectionsUrl}/${r}/`;

      });
    }
  }

  window.Filter = Filter;
  console.log("finder.js loaded (vanilla)");
})();
